class YAxisChartDefinition {
    yAxisID: KnockoutObservable<string> = ko.observable("y-left");
    chartType: KnockoutObservable<ChartType> = ko.observable(ChartType.Bar);
    bubbleType: KnockoutObservable<BubbleScatterType> = ko.observable(BubbleScatterType.YAxis);
    scatterType: KnockoutObservable<BubbleScatterType> = ko.observable(BubbleScatterType.YAxis);
    stackGroup: KnockoutObservable<number> = ko.observable(0);

    constructor(data?: any) {
        if (!data) {
            return;
        }

        this.yAxisID(data.yAxisID ?? "y-left");
        this.chartType(data.chartType ?? ChartType.Bar);
        this.bubbleType(data.bubbleType ?? BubbleScatterType.YAxis);
        this.scatterType(data.scatterType ?? BubbleScatterType.YAxis);
        this.stackGroup(data.stackGroup ?? 0);
    }

    getBubbleOrScatterType(fieldName: "bubbleType" | "scatterType") {
        if (fieldName === "bubbleType") {
            return this.bubbleType;
        }
        else {
            return this.scatterType;
        }
    }

    setBubbleOrScatterType(fieldName: "bubbleType" | "scatterType", value: BubbleScatterType) {
        this.getBubbleOrScatterType(fieldName)(value);
    }

    isSerie(chartDefinition: ChartDefinition) {
        if (chartDefinition.chartType() === ChartType.Bubble && this.bubbleType() !== BubbleScatterType.YAxis) {
            return false;
        }
        if (chartDefinition.chartType() === ChartType.Scatter && this.scatterType() !== BubbleScatterType.YAxis) {
            return false;
        }
        return true;
    }
}